import { useLang } from "@/context/LanguageContext";

// Voci raggruppate per genere: identità, risultati sportivi, onorificenze.
// Ogni genere ha il suo separatore colorato per distinguere i gruppi nello scorrimento.
const GROUPS = [
  { key: "identity", dot: "bg-sky-400/70" },
  { key: "results", dot: "bg-amber-400/70" },
  { key: "honors", dot: "bg-emerald-400/70" },
];

export default function Marquee() {
  const { t } = useLang();
  const items = GROUPS.flatMap((g) => (t(`marquee.${g.key}`) || []).map((label) => ({ label, dot: g.dot })));
  const row = [...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-slate-800/70 bg-[#0C1220] py-5 select-none" aria-hidden="true">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-2xl sm:text-3xl tracking-[0.12em] text-slate-500 whitespace-nowrap">{item.label}</span>
            <span className={`h-1.5 w-1.5 rotate-45 ${item.dot} shrink-0`} />
          </span>
        ))}
      </div>
    </div>
  );
}
